import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { GlobalProvider } from "context/GlobalContext.jsx";
import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import { Provider as ReduxProvider } from "react-redux";
import App from "./App.jsx";
import { msalConfig } from "./authConfig"; // Ensure this is the correct path
import "./index.scss";
import { store } from "./redux/store.js";

// Create a new MSAL instance using msalConfig
const msalInstance = new PublicClientApplication(msalConfig);

function Root() {
  const [initialized, setInitialized] = useState(false);

  // Wait for the MSAL instance to initialize before rendering the app
  useEffect(() => {
    const initializeMSAL = async () => {
      try {
        await msalInstance.initialize(); // Wait for initialization

        setInitialized(true);
      } catch (error) {}
    };

    initializeMSAL();
  }, []);

  // Render the application only after MSAL is initialized
  if (!initialized) {
    return null; // You can customize this loading state as needed
  }

  return (
    <React.StrictMode>
      <ReduxProvider store={store}>
        <MsalProvider instance={msalInstance}>
          <GlobalProvider>
            <App />
          </GlobalProvider>
        </MsalProvider>
      </ReduxProvider>
    </React.StrictMode>
  );
}

// Create root element and render the app
ReactDOM.createRoot(document.getElementById("root")).render(<Root />);
